import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { registerSW } from 'virtual:pwa-register'
import { App } from './App'
import { useAppUpdateStore } from './lib/appUpdate'
import './styles/broadsheet.css'
import './styles/theme.css'

const container = document.getElementById('root')

if (container === null) {
  throw new Error('The #root element is missing from index.html.')
}

/**
 * The service worker that makes the app open with no network (issue #64).
 *
 * Registered here and nowhere else: `virtual:pwa-register` is generated by the
 * build, so importing it anywhere Jest reaches would be a module that does not
 * exist. What the rest of the app talks to is the store below.
 *
 * A newer build is offered rather than applied — see src/lib/appUpdate.ts for
 * why a walk round a building must not be interrupted by a reload nobody asked
 * for.
 */
const updateServiceWorker = registerSW({
  onNeedRefresh: () => {
    useAppUpdateStore.getState().offer(() => {
      void updateServiceWorker(true)
    })
  },
})

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
